<template>
  <div
    class="snackbar snackbar_show"
    :class="{
      snackbar_hide: isHide,
    }"
    @click="$emit('reopen')"
  >
    <div class="snackbar__title">
      {{ message }} <span>{{ $t("forms.snackbarReopen") }}</span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'app-snackbar',
    props: {
        message: {
            required: false,
            default: 'You\'ve closed order modal window.',
            type: String,
        },
    },
    data() {
        return {
            isHide: false,
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
    },
    mounted() {
        setTimeout(() => {
            this.isHide = true

            setTimeout(() => {
                this.isHide = false
                this.close()
            }, 200)
        }, 10000)
    },
}
</script>

<style lang="scss" scoped>
.snackbar {
  position: absolute;
  right: 30px;
  bottom: 90px;
  background-color: #f0b21a;
  padding: 20px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
  color: #fff;
  user-select: none;
  z-index: 9999;
  cursor: pointer;

  &__title {
    font-weight: 600;
    font-size: 17px;
  }

  &__action {
    margin-left: 16px;
  }

  &__button {
    background-color: transparent;
    border: 3px solid #ededed;
    padding: 5px;
    cursor: pointer;
    transition: all 0.2s ease-in;
    user-select: none;
    color: #fff;
    font-weight: 600;

    &:hover {
      background-color: #cc921e;
    }
  }

  &_show {
    animation: show 0.2s ease-in;
  }

  &_hide {
    animation: hide 0.2s ease-in;
  }
}

@keyframes show {
  0% {
    opacity: 0;
    transform: translate3d(30px, 0, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes hide {
  0% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(30px, 0, 0);
  }
}
</style>
